import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useRef } from 'react';
import { getClassNames } from 'module-tsl-ui-jobs-common';
import { shouldDisplayEmployerLogo } from './helpers';
import { JobContext } from './JobContext';
import { EmployerLogo, JobTitle, JobLocation, JobDescription, SalaryDescription, JobFlags, JobLink, JobDates, CallToAction } from './components';
var prefix = 'tds-job-card';
export var JobCard = function JobCard(props) {
  var _objectSpread2;

  var jobContext = _objectSpread({
    prefix: prefix
  }, props);

  var forceSmall = jobContext.forceSmall,
      cardStyle = jobContext.cardStyle,
      extraClasses = jobContext.extraClasses,
      modulesV2 = jobContext.modulesV2,
      forceLogo = jobContext.forceLogo,
      isNurtured = jobContext.isNurtured,
      isMobile = jobContext.isMobile,
      forceSalaryDescription = jobContext.forceSalaryDescription;
  var isGold = jobContext["package"] === 'gold';
  var isSilver = jobContext["package"] === 'silver';
  var isSilverOrGold = isGold || isSilver;
  var isSponsored = ['sponsored-job', 'silver-sponsored-job'].indexOf(cardStyle) > -1;
  var hasEmployerLogo = shouldDisplayEmployerLogo(cardStyle, modulesV2);
  var isSimple = !(hasEmployerLogo || forceLogo);
  var isSmall = Boolean(forceSmall);
  var className = getClassNames(_objectSpread((_objectSpread2 = {}, _defineProperty(_objectSpread2, prefix, true), _defineProperty(_objectSpread2, "".concat(prefix, "--mobile"), isMobile), _defineProperty(_objectSpread2, "".concat(prefix, "--sm"), isSmall), _defineProperty(_objectSpread2, "".concat(prefix, "--gold"), isGold), _defineProperty(_objectSpread2, "".concat(prefix, "--silver"), isSilver), _defineProperty(_objectSpread2, "".concat(prefix, "--simple"), isSimple), _defineProperty(_objectSpread2, "".concat(prefix, "--sponsored"), isSponsored), _defineProperty(_objectSpread2, ["".concat(prefix, "--nurtured")], isNurtured), _objectSpread2), extraClasses));
  var urlRef = useRef(null);

  var redirect = function redirect(e) {
    if (e.type === 'click' || e.keyCode === 13) {
      urlRef.current.click();
    }
  };

  return /*#__PURE__*/React.createElement(JobContext.Provider, {
    value: jobContext
  }, /*#__PURE__*/React.createElement("div", {
    className: className,
    onClick: redirect,
    onKeyDown: redirect
  }, /*#__PURE__*/React.createElement(EmployerLogo, null), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "__content")
  }, isSponsored && /*#__PURE__*/React.createElement("p", {
    className: "".concat(prefix, "__type")
  }, "\u2605 Sponsored"), /*#__PURE__*/React.createElement(JobLink, {
    reference: urlRef
  }, /*#__PURE__*/React.createElement(JobTitle, null)), /*#__PURE__*/React.createElement(JobLocation, null), /*#__PURE__*/React.createElement(JobFlags, {
    size: isSmall || isMobile ? 'sm' : 'md'
  }), /*#__PURE__*/React.createElement(JobDescription, null), (isSilverOrGold || forceSalaryDescription) && /*#__PURE__*/React.createElement(SalaryDescription, null)), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "__info")
  }, /*#__PURE__*/React.createElement(JobDates, null), /*#__PURE__*/React.createElement(CallToAction, null))));
};
JobCard.displayName = "JobCard";